import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import App from './App.vue'
import router from './router'
import store from './store'
import auth from '@/directives/auth'
import { BaseUrl } from '@/utils/config'

const flattenMenuTree = (list = []) => {
  const flatList = []

  list.forEach(item => {
    flatList.push(item)
    if (Array.isArray(item.children) && item.children.length > 0) {
      flatList.push(...flattenMenuTree(item.children))
    }
  })

  return flatList
}

const restoreStoreState = () => {
  const persistedStore = window.sessionStorage.getItem('store')
  if (!persistedStore) {
    return
  }

  store.replaceState(Object.assign({}, JSON.parse(persistedStore)))
  window.sessionStorage.removeItem('store')
}

const syncActionMenus = async () => {
  const token = store.getters['basic/get_token']
  if (!token) {
    return
  }

  try {
    const response = await fetch(`${BaseUrl}/api/admin/v1/menu/myTree`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({}),
    })

    const result = await response.json()
    if (result.code === 0) {
      await store.dispatch('basic/up_action', flattenMenuTree(result.data || []))
    }
  } catch (error) {
    console.error('同步按钮权限失败:', error)
  }
}

const bootstrap = async () => {
  restoreStoreState()
  await syncActionMenus()

  const app = createApp(App);

  app.use(ElementPlus,{locale:zhCn});
  app.use(store);
  app.use(router);
  app.directive('auth', auth);
  app.mount('#app');
}

bootstrap()
